module.exports = __webpack_public_path__ + "img/top_conbadge.414454cc.jpg";